export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-v1-960-c9da3d7bb80fd5f157df39d20d79597e.webp";